import { Options } from '@sheerid/jslib';
import { RecursivePartial } from './lib/types/types';


export const programId = '627d34a2841b6950011d19e0';

export const defaultOptions: RecursivePartial<Options> = {
    restApi: {
        serviceUrl: 'https://services.sheerid.com/',
    },

    logLevel: 'error',
    useFingerprinting: true,
};
